<template>
  <div v-if="formData">
    <div class="row mt-5 b-form__row_type_flex">
      <div class="col-4">
        <label for="lastName">
          {{$t('CONTENT.counterparty.lastName')}}
          <span class="b-form__required">*</span>
        </label>
        <input
          data-cy="choose-last-name"
          type="text"
          id="lastName"
          class="b-input"
          name="lastName"
          v-model="formData.lastName"
        />
      </div>
      <div class="col-4">
        <label for="firstName">
          {{$t('CONTENT.counterparty.firstName')}}
        </label>
        <input
          data-cy="choose-first-name"
          type="text"
          id="firstName"
          class="b-input"
          name="firstName"
          v-model="formData.firstName"
        />
      </div>
      <div class="col-4">
        <label for="patronymic">{{$t('CONTENT.counterparty.patronymic')}}</label>
        <input
          data-cy="choose-patronymic"
          type="text"
          id="patronymic"
          class="b-input"
          name="patronymic"
          v-model="formData.patronymic"
        />
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-3">
        <label for="itn">
          {{$t('CONTENT.counterparty.itn')}}
<!--          <span class="b-form__required">*</span>-->
        </label>
        <input
          type="text"
          id="itn"
          class="b-input"
          name="ITN"
          v-model="formData.itn" />
      </div>
    </div>
    <div class="row mt-5 b-form__row_type_flex">
      <div class="col-5">
        <label for="passportSeries">{{$t('CONTENT.counterparty.series_and_passport_number')}}</label>
        <div class="row">
          <div class="col-5 pr-0">
            <input
              data-cy="choose-passport-serial-number"
              type="text"
              id="passportSeries"
              class="b-input"
              name="passportSeries"
              v-model="formData.russianPassport.passportSerialNumber"
            />
          </div>
          <div class="col-7">
            <input
              data-cy="choose-passport-number"
              type="text"
              id="passportId"
              class="b-input"
              name="passportId"
              v-model="formData.russianPassport.passportNumber"
            />
          </div>
        </div>
      </div>
      <div class="col-7">
        <label for="issuer">{{$t('CONTENT.counterparty.issuer')}}</label>
        <input
          data-cy="choose-passport-issuer"
          type="text"
          id="issuer"
          class="b-input"
          name="issuer"
          v-model="formData.russianPassport.issuer"
        />
      </div>
    </div>
    <div class="row mt-5 b-form__row_type_flex">
      <div data-cy="choose-issue-date" class="col-3">
        <label>{{$t('CONTENT.counterparty.passport_date')}}</label>
        <datepicker class="b-datepicker" v-model="passportDate" placeholder="" :formatter="datepickerFormat"></datepicker>
      </div>
      <div class="col-4">
        <label for="latinName">{{$t('CONTENT.counterparty.passport_code')}}</label>
        <input
          data-cy="choose-passport-division-code"
          type="text"
          id="latinName"
          class="b-input"
          name="latinName"
          v-model="formData.russianPassport.divisionCode"
        />
      </div>
    </div>
    <CounterpartyAddressForm :addresses="formData.addresses" />
    <div class="row mt-5 b-form__row_type_flex">
      <div class="col-6">
        <label for="externalId">{{$t('CONTENT.external_id')}}:</label>
        <input
          data-cy="choose-externalId"
          type="text"
          id="externalId"
          class="b-input"
          name="externalId"
          v-model="formData.externalId"
        />
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-8">
        <div class="b-form__container">
          <label for="input9">{{$t('CONTENT.comment')}}:</label>
          <textarea
            data-cy="choose-comment"
            class="b-textarea"
            id="input9"
            name="name2"
            v-model="formData.comment"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import { mapGetters } from 'vuex';
	import datepickerFormat from '@/mixins/datepickerFormat.mixin';
	import CounterpartyAddressForm from "./CounterpartyAddressForm";

	export default {
		components: {
			CounterpartyAddressForm
    },
    mixins: [datepickerFormat],
		props:{
			formData: {
				required: true,
				type: Object,
			}
		},
		computed: {
			...mapGetters(['allDirectoryLegalForms']),
      ...mapGetters(['allCounterpartyAddressTypes']),
      passportDate: {
			  get() {
          if (this.formData.russianPassport.yearDateDateOfIssue == null) {
            return null;
          }
          // Or take it from data
          else {
            return new Date(
              this.formData.russianPassport.yearDateDateOfIssue,
              this.formData.russianPassport.monthDateDateOfIssue - 1,
              this.formData.russianPassport.dayDateDateOfIssue);
          }
        },
        set(newVal) {
			    if (newVal !== null) {
            this.formData.russianPassport.dayDateDateOfIssue = newVal.getDate();
            this.formData.russianPassport.monthDateDateOfIssue = newVal.getMonth() + 1;
            this.formData.russianPassport.yearDateDateOfIssue = newVal.getFullYear();
          } else {
            this.formData.russianPassport.dayDateDateOfIssue = null;
            this.formData.russianPassport.monthDateDateOfIssue = null;
            this.formData.russianPassport.yearDateDateOfIssue = null;
          }
        }
      }
		},
	};
</script>
